// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3cf47d5c","488":"ee4ef0bc","492":"3309e606","977":"7be3420e"}[chunkId] + ".chunk.js";
};